import React from 'react';
import QuickTradeButton from './QuickTradeButton';
import { useAuth } from '../../contexts/AuthContext';
import { useWallet } from '../../contexts/WalletContext';
import '../../styles/quick-trade-buttons.css';

const QuickTradeActions = ({ token, onTradeComplete }) => {
  const { isAuthenticated } = useAuth();
  const { wallets, activeWallet } = useWallet();

  // Check if user has a platform wallet for trading
  const platformWallet = wallets.find(w => w.wallet_type === 'platform') || activeWallet;
  const canTrade = isAuthenticated && platformWallet && platformWallet.wallet_type === 'platform';

  // Handle trade completion
  const handleTradeComplete = (tradeData) => {
    if (onTradeComplete) {
      onTradeComplete(tradeData);
    }
  };

  // Show login prompt if not authenticated
  if (!isAuthenticated) {
    return (
      <div className="quick-trade-actions">
        <div className="auth-required-message">
          <span className="auth-icon">🔐</span>
          <span className="auth-text">Login to trade</span>
          <button 
            className="login-link-btn"
            onClick={() => window.location.href = '/login'}
          >
            Login
          </button>
        </div>
      </div>
    );
  }

  // Show wallet connection prompt if no platform wallet
  if (!canTrade) {
    return (
      <div className="quick-trade-actions">
        <div className="wallet-required-message">
          <span className="wallet-icon">💼</span>
          <span className="wallet-text">Platform wallet needed</span>
          <button 
            className="connect-wallet-btn"
            onClick={() => {
              // Navigate to wallet management or trigger wallet creation
              const event = new CustomEvent('openWalletManager');
              window.dispatchEvent(event);
            }}
          >
            Connect
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="quick-trade-actions">
      <div className="quick-trade-section-title">
        <span className="quick-trade-icon">⚡</span>
        <span className="quick-trade-title">Quick Trade</span>
      </div>
      
      {/* Buy Row */}
      <div className="quick-trade-row">
        <div className="quick-trade-row-label">Buy:</div>
        <div className="quick-trade-buttons">
          <QuickTradeButton 
            type="buy" 
            percentage={25} 
            token={token} 
            onTradeComplete={handleTradeComplete}
          />
          <QuickTradeButton 
            type="buy" 
            percentage={50} 
            token={token} 
            onTradeComplete={handleTradeComplete}
          />
          <QuickTradeButton 
            type="buy" 
            percentage={75} 
            token={token} 
            onTradeComplete={handleTradeComplete}
          />
          <QuickTradeButton 
            type="buy" 
            percentage={100} 
            token={token} 
            onTradeComplete={handleTradeComplete}
          />
        </div>
      </div>

      {/* Sell Row */}
      <div className="quick-trade-row">
        <div className="quick-trade-row-label">Sell:</div>
        <div className="quick-trade-buttons">
          <QuickTradeButton 
            type="sell" 
            percentage={25} 
            token={token} 
            onTradeComplete={handleTradeComplete}
          />
          <QuickTradeButton 
            type="sell" 
            percentage={50} 
            token={token} 
            onTradeComplete={handleTradeComplete}
          />
          <QuickTradeButton 
            type="sell" 
            percentage={75} 
            token={token} 
            onTradeComplete={handleTradeComplete}
          />
          <QuickTradeButton 
            type="sell" 
            percentage={100} 
            token={token} 
            onTradeComplete={handleTradeComplete}
          />
        </div>
      </div>
    </div>
  );
};

export default QuickTradeActions;